import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { Settings } from "luxon";
import TRANSLATIONS_EN from "./translations_en";
import TRANSLATIONS_ES from "./translations_es";
import { setApiLanguage } from "../utils/api";

const AVAILABLE_LOCALES = ['en', 'es'];

export const initLocale = () => {
  i18next
    .use(initReactI18next)
    .init({
      // we init with resources
      resources: {
        en      : { translations: TRANSLATIONS_EN },
        es      : { translations: TRANSLATIONS_ES },
      },
      fallbackLng: "en",
      lng: "en",
      debug: process.env.REACT_APP_LOCALE_DEBUG === 'true',
  
      // have a common namespace used around the full app
      ns: ["translations"],
      defaultNS: "translations",
  
      keySeparator: false, // we use content as keys
  
      interpolation: {
        escapeValue: false
      }
    });
}

export function setLocaleFromParam() {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  if (params.lang && i18next.options.resources[params.lang]) {
    i18next.changeLanguage(params.lang);
  }
}

export const t = i18next.t;

export function setLanguage(language) {
  if (AVAILABLE_LOCALES.includes(language)) {
    i18next.changeLanguage(language);
    setApiLanguage(language);
    Settings.defaultLocale = language;
  }
  else {
    console.warn("Language " + language + " is not in the list: " + AVAILABLE_LOCALES.join(', '));
  }
}

export function localeNumber(number) {
  return number.toLocaleString(i18next.language);
}